// External packages
import * as ReactAria from 'react-aria-components';

// Utils
import { twMerge } from 'tailwind-merge';

// Components
import { Icon } from 'components/Icons';

export const TriggerRoot = ReactAria.DialogTrigger;

export const Overlay: React.FC<
  React.ComponentProps<'div'> & ReactAria.ModalOverlayProps
> = ({ className, ...props }) => (
  <ReactAria.ModalOverlay
    {...props}
    className={twMerge(
      'data-exiting:animate-modal-fade-out data-entering:animate-modal-fade-in fixed top-0 left-0 z-100 flex h-(--visual-viewport-height) w-screen items-center justify-center bg-gray-900/50 p-6',
      className
    )}
  />
);

export const Root: React.FC<
  React.ComponentProps<'div'> & ReactAria.ModalOverlayProps
> = ({ className, ...props }) => (
  <ReactAria.Modal
    {...props}
    className={twMerge(
      'data-entering:animate-modal-zoom relative max-h-full w-full overflow-y-auto rounded-lg bg-white px-6 py-8',
      className
    )}
  />
);

export const Dialog: React.FC<
  React.ComponentProps<'div'> & ReactAria.DialogProps
> = ({ className, ...props }) => (
  <ReactAria.Dialog {...props} className={twMerge('outline-0', className)} />
);

export const Close: React.FC<
  React.ComponentProps<'button'> & ReactAria.ButtonProps
> = ({ className, ...props }) => (
  <ReactAria.Button
    {...props}
    slot="close"
    className={twMerge('absolute top-2.5 right-2.5 cursor-pointer', className)}
  >
    <Icon name="x" className="size-6" />
  </ReactAria.Button>
);
